import styled from 'styled-components';

export const FormFieldWrapper = styled.div`
  .error {
    color: #da4444;
    font-size: 12px;
    font-style: normal;
    font-weight: 400;
    line-height: 120%; /* 14.4px */
  }
`;

export const CustomCheckboxLabel = styled.label`
  position: relative;
  display: inline-block;
  vertical-align: middle;
  padding-left: 32px;
  cursor: pointer;
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  line-height: 20px; /* 166.667% */
`;

export const HiddenCheckbox = styled.input.attrs({ type: 'checkbox' })`
  position: absolute;
  opacity: 0;
  cursor: pointer;
`;

export const CheckboxIcon = styled.span`
  position: absolute;
  top: 0;
  left: 0;
  height: 20px;
  width: 20px;
  border-radius: 4px;
  background: #3d3c41;
  ${HiddenCheckbox}:checked + & {
    background: #ff6601;

    &:after {
      content: '';
      position: absolute;
      width: 100%;
      height: 100%;
      top: 0;
      left: 0;
      background-image: url(/images/icons/checkmark.svg);
      background-repeat: no-repeat;
      background-position: center;
    }
  }
`;

export const CheckmarkIcon = styled.span`
  position: absolute;
  content: '';
  display: none;

  ${HiddenCheckbox}:checked + ${CheckboxIcon} & {
    display: block;
  }

  left: 7px;
  top: 3px;
  width: 6px;
  height: 12px;
  border: solid white;
  border-width: 0 3px 3px 0;
  transform: rotate(45deg);
`;
